import { isProduction } from "../utils/env";

export const STATIC_FILE_BASE_URL = isProduction
  ? "https://production-kome-ichiba-files.s3-ap-northeast-1.amazonaws.com"
  : "https://testing-kome-ichiba-files.s3-ap-northeast-1.amazonaws.com";

export const CSV_ROWS = 1000;
